// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3954 ? "d3ac728e" : chunkId) + "." + {"3081":"3a62c6873bf02234","3657":"9d1868807bed47b2","3954":"e315a6df3db5703b","5864":"6fe3cdd192dc8406"}[chunkId] + ".js";
};